import React from 'react'
import PropTypes from 'prop-types'
import {
  Logo,
  IconManager,
  subscriptionsLogoPack,
  ThemeProvider,
  Level,
  coreIconPack,
  Link,
} from '@deseretbook/react-ui'
import AccountLogo from './assets/Account.svg'
import SearchLogo from './assets/Search.svg'
import Back2DB from './assets/Back_to_Deseret_Book.svg'

/**
 * Renders the Header component for Video Discovery (VideoDiscoveryHome.jsx and ChannelList.jsx)
 *
 * @param {boolean} searchEnabled Simple feature flag to hide (false) / show (true) the search button.
 * @param {boolean} catagoriesEnabled Simple feature flag to hide (false) / show (true) the search button.
 *
 * @returns {function} React Component
 */
const VideoDiscoverHeader = ({ searchEnabled, catagoriesEnabled }) => {
  IconManager.register(subscriptionsLogoPack, coreIconPack)

  return (
    <ThemeProvider>
      <Level>
        <Level.Left className="header-logo">
          <Level.Item>
            <Logo name="deseretVideoPlus" color="video" size="responsive" isLarge />
          </Level.Item>
        </Level.Left>
        {catagoriesEnabled ? (
          // TODO: Links for catagories

          <Level.Item>
            <div>
              <Link href="/t/Movies">
                <h2 className="video-catagory">Movies</h2>
              </Link>
            </div>
            <div>
              <Link href="/t/Seek">
                <h2 className="video-catagory">Seek</h2>
              </Link>
            </div>
            <div>
              <Link href="/t/Seek">
                <h2 className="video-catagory">TOFW</h2>
              </Link>
            </div>
            <div>
              <Link href="/t/Seek">
                <h2 className="video-catagory">LDS Living</h2>
              </Link>
            </div>
            <div>
              <Link href="/t/Seek">
                <h2 className="video-catagory">Music</h2>
              </Link>
            </div>

            {/* TODO: Your List implementation */}
            <div>
              <Link href="/">
                <h2 className="video-catagory">Your List</h2>
              </Link>
            </div>
          </Level.Item>
        ) : (
          <React.Fragment />
        )}

        <Level.Right className="navbar-buttons">
          <Level.Item>
            <Link href="/">
              <img src={Back2DB} alt="Back to DB Store" />
            </Link>
          </Level.Item>
          {searchEnabled ? (
            <Level.Item>
              {/* TODO: Search button, w/ search modal */}
              <img src={SearchLogo} alt="Search" name="search" />
            </Level.Item>
          ) : (
            <React.Fragment />
          )}

          <Level.Item>
            <Link href="/login">
              <img src={AccountLogo} alt="Account" />
            </Link>
          </Level.Item>
        </Level.Right>
      </Level>
    </ThemeProvider>
  )
}

VideoDiscoverHeader.propTypes = {
  searchEnabled: PropTypes.bool,
  catagoriesEnabled: PropTypes.bool,
}

export default VideoDiscoverHeader
